export default __webpack_public_path__ + "static/page-header-dont-1-2c1cc130a41588d272400c493245133e54d63fc80dd3e456fe307b60cbb28f66.png";